import * as React from 'react';
import * as Modal from 'react-modal';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ApplicationState } from 'stores'
import { HooplaPurchase, PaginationMeta} from 'types';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';
import Button from 'components/Button';
import {fetchPurchases} from "../../stores/eventPurchases";
import { ContainerLoader } from 'components/Loading';
import Pagination from 'components/Pagination';
import TicketList from 'components/TicketList';
import * as styles from './styles';

interface IProps {
  userId: number;
  fetchPurchases: (offset: number) => void;
  purchases: HooplaPurchase[];
  pagination: PaginationMeta;
  loading: boolean;
  error: boolean;
}

Modal.setAppElement('#root');

class Tickets extends React.Component<IProps> {
  componentDidMount() {
    this.fetchTickets();
  }

  fetchTickets = () => {
    this.props.fetchPurchases(0);
  };

  paginationClick = ({ selected }: { selected: number }) => {
    if (
      selected ===
      this.props.pagination.offset / this.props.pagination.limit
    ) {
      return;
    }

    this.props.fetchPurchases(
      selected * this.props.pagination.limit
    );
  };

  render() {
    if (this.props.loading) {
      return <ContainerLoader />;
    }

    if (this.props.error) {
      return (
        <div className={styles.error}>
          <Typography type="subheading">
            <FormattedMessage id="containers.Tickets.genericError" />
          </Typography>
          <Button onClick={this.fetchTickets}>
            <FormattedMessage id="containers.Tickets.tryAgain" />
          </Button>
        </div>
      );
    }

    if (this.props.purchases.length === 0) {
      return (
        <PageHeader>
          <FormattedMessage id="containers.Tickets.noTickets" />
        </PageHeader>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.container}>
          <PageHeader>
            <FormattedMessage id="containers.Tickets.yourTickets" />
          </PageHeader>
          <TicketList list={this.props.purchases} />
          {this.props.purchases.length > 0 &&
            this.props.pagination.total / this.props.pagination.limit > 1 && (
              <Pagination
                pagination={this.props.pagination}
                onPageChange={this.paginationClick}
              />
            )}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    userId: state.user.userData.userId,
    loading: state.purchases.fetching || !state.purchases.fetched,
    purchases: state.purchases.purchases,
    error: state.purchases.error,
    pagination: state.purchases.pagination
  }),
  { fetchPurchases }
)(Tickets);
